module.exports = __webpack_public_path__ + "components/rewards/app/static/logo-2dd728a4541f84b6e8c17b42a903cb50.jpg";